import { Appearances } from './types';
import * as React from 'react';
import { ButtonText } from './button';
import styles from './styles.scss';

interface CardInformationContainerProps {
  children?: React.ReactNode;
}

const CardInformationContainer = ({ children }: CardInformationContainerProps) => {
  return <div className={styles.cardInformationContainer}>{children}</div>;
};

interface CardInformationProps extends Appearances {
  text?: string;
  title?: string;
}

export const CardInformation = ({ text = '', appearance, title = '' }: CardInformationProps) => (
  <CardInformationContainer>
    <ButtonText text={title} isBold appearance={appearance} />
    <ButtonText text={text} appearance={appearance} />
  </CardInformationContainer>
);
